import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  useTheme,
} from "@mui/material";
import AIICON from "../../assets/icons/ai.png";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useState } from "react";
import AIAssessmentDialog from "./AIAssessmentDialog";

const AIAssessmentCard = ({ setLoader, loader, setAssessment }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [createdFirstTime, setCreatedFirstTime] = useState(false);

  const theme = useTheme();

  return (
    <>
      <Card
        sx={{
          my: 2,
          background: "linear-gradient(135deg, #E3F2FD 0%, #F3E5F5 100%)",
          borderRadius: 3,
          padding: 2,
          minHeight: 100,
          display: "flex",
          alignItems: "center",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: 0,
            "&:last-child": { paddingBottom: 0 },
          }}
        >
          {/* Left side with icon and text */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {/* AI Icon */}
            <Box component="img" src={AIICON} height={60} />

            {/* Text content */}
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#536370",
                  marginBottom: 0.5,
                  fontSize: "1.1rem",
                }}
              >
                Create Assessment using AI
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#2A95AB",
                  fontSize: "0.9rem",
                }}
              >
                AI will create assessment using job description
              </Typography>
            </Box>
          </Box>

          {/* Right side with button */}
          <Button
            variant="contained"
            disabled={loader}
            startIcon={
              <AutoAwesomeIcon
                sx={{ width: "1.125rem", height: "1.125rem", color: "white" }}
              />
            }
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: 2,
              padding: "10px 24px",
              fontFamily: "Outfit",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.9rem",
              boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
                boxShadow: "0 6px 16px rgba(102, 126, 234, 0.4)",
              },
            }}
            onClick={() => setDialogOpen(true)}
          >
            {createdFirstTime ? "Re-create" : "Create New"}
          </Button>
        </CardContent>
      </Card>

      <AIAssessmentDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        setLoader={setLoader}
        loader={loader}
        setAssessment={setAssessment}
        setCreatedFirstTime={setCreatedFirstTime}
      />
    </>
  );
};

export default AIAssessmentCard;
